import SharepointTab from "../../AllEquipments/CommonFeatures/DCSTab/SharepointTab";
import { DCSProvider } from "../../AllEquipments/CommonFeatures/DCSTab/Table/DCSContext";
import TankMain from "../../AllEquipments/Tank/Main";
import MainProjects from "../../Project/allProjectsPage";
import DocReviewer from "../../AllEquipments/CommonFeatures/DCSTab/DocReviewer";
import DataHistorian from "../../AllEquipments/CommonFeatures/AssetManagementTab";
import MaterialRecords from "../../MaterialRecords";
import { Box } from "@mui/material";

export const amsTabs = (reRender, projectId) => [
  {
    title: "Smart P&ID",
    panel: <SharepointTab reRender={reRender} />,
  },
  {
    title: "Digital 3D Modeling",
    panel: <SharepointTab reRender={reRender} />,
  },
  {
    title: "PLM",
    panel: (
      <DCSProvider>
        <TankMain />
      </DCSProvider>
    ),
  },
  {
    title: "Digital Twin",
    panel: <div>Not Implemented</div>,
  },
  {
    title: "Data Historian",
    panel: (
      <Box pt={2}>
        <DataHistorian />,
      </Box>
    ),
  },
  {
    title: "Process Calculation",
    panel: <div>Not Implemented</div>,
  },
  {
    title: "Predictive Maintenance",
    panel: (
      <Box p={2}>
        <DocReviewer projectId={projectId} />,
      </Box>
    ),
  },
  {
    title: "Plant Modification",
    panel: (
      <Box p={2}>
        <DocReviewer projectId={projectId} />,
      </Box>
    ),
  },
  {
    title: "Spare Parts",
    panel: <MaterialRecords />,
  },
  {
    title: "Projects",
    panel: <MainProjects />,
  },
];
